import * as React from 'react';
import { view, createViewConfig, dynamic, media } from '@sail/engine';
import { tokens, css } from '@sail/ui';
import { styles, variants } from './ColumnLayoutStyles';
import { RowLayoutConfig } from '../RowLayout/RowLayout';
export const ColumnLayoutConfig = createViewConfig({
    props: {},
    name: 'ColumnLayout',
    defaults: {
        rowGap: 'large',
        align: 'start',
        columns: '2,2'
    }
});
/**
 * Creates a CSS grid template string based on an array of column sizes.
 */ export const createCSSGrid = (arr)=>{
    if (arr.length === 0) {
        return '';
    }
    const allEqual = arr.length > 1 && arr.every((val)=>val === arr[0]);
    if (allEqual) {
        return `repeat(${arr.length}, minmax(0, ${arr[0].trim()}fr))`;
    }
    const cols = arr.map((n)=>`minmax(0, ${n.trim()}fr)`).join(' ');
    return cols;
};
/**
 * Layout component used to handle horizontal column layout
 */ export const ColumnLayout = ColumnLayoutConfig.createView((props)=>{
    const { align, children, columns, columnsTablet, reflowDirection, ...rest } = props;
    return /*#__PURE__*/ React.createElement(view.div, {
        "data-testid": "column-layout",
        "data-state-column-count": columns,
        "data-state-reflow-direction": reflowDirection,
        ...rest
    }, children);
}, {
    uses: [
        styles.columnLayout,
        styles.globalColumnLayout,
        dynamic(({ columns, columnsTablet, align })=>{
            const intents = [];
            if (columns) {
                const columnsTemplate = createCSSGrid(columns.split(','));
                const usesTwoColumnsByDefaultOnTablet = [
                    /* 3 column layouts used for blog/guides/newsroom */ '1,1,1',
                    '2,1',
                    /* 4 column layouts used for product pages */ '1,1,1,1',
                    '2,2',
                    '2,1,1',
                    '2,1,0',
                    /* 5 column layouts used for our heros when the title needs to take up 3 columns */ '3,2'
                ];
                if (usesTwoColumnsByDefaultOnTablet.includes(columns)) {
                    intents.push(css({
                        [media.up(tokens.viewport.small)]: {
                            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
                        }
                    }));
                }
                if (columnsTablet) {
                    const columnsTabletTemplate = createCSSGrid(columnsTablet.split(','));
                    intents.push(css({
                        [media.between(tokens.viewport.small, tokens.viewport.large)]: {
                            gridTemplateColumns: columnsTabletTemplate
                        }
                    }));
                }
                intents.push(css({
                    [media.up(tokens.viewport.large)]: {
                        gridTemplateColumns: columnsTemplate
                    }
                }));
                if (align === 'stretch') {
                    const RowLayoutCustomizations = RowLayoutConfig.customize({
                        defaults: {
                            stretchLastItem: true
                        }
                    });
                    intents.push(RowLayoutCustomizations);
                }
            }
            return intents;
        })
    ],
    forward: {
        align: true
    },
    variants
});

//# sourceMappingURL=ColumnLayout.js.map